import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CartRow, CartService } from 'gung-standard';
import { JeevesSalesCartConfigService } from 'gung-standard-jeeves';
import { RefSalesCartListComponent } from '../../components/cart/ref-sales-cart-list/ref-sales-cart-list/ref-sales-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class RefSalesCartConfigService extends JeevesSalesCartConfigService {
  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => RefSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
